import React, { FC } from 'react'

import styled from 'styled-components'

import { Icon, Txt } from 'src/components/atoms'

const Container = styled.div`
  background: rgba(255, 255, 255, 0.7);
  width: 100%;
  height: 100%;
  border-radius: var(--s-2);
`

type Props = {
  className?: string
}

export const CommonContentAssetDropArea: FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <Container className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-border-3 tw-border-dashed tw-border-pattern2-2">
        <div className="tw-bg-pattern2-2 tw-w-[4rem] tw-aspect-square tw-rounded-full tw-centering">
          <Icon path="arrow-down/soft/line" className="tw-text-inlineText-primary" size="--r1" />
        </div>
        <Txt className="tw-text-pattern2-2">ファイルをドロップ</Txt>
      </Container>
    </div>
  )
}
